"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _lifehikesInitData = require("@/lifehikes-init-data");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _hikeAdvancedReport = require("@/api/hike-advanced-report");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _index = _interopRequireDefault(require("../../../components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HikeAdvancedReportList',
  components: {
    SearchBox: _index.default
  },
  mixins: [_autoTableHeight.autoTableHeight],
  filters: {
    getInternalTitle(value) {
      // console.log('row value', value)
      return typeof value === 'undefined' ? '' : value.title;
    }
  },
  data() {
    return {
      tableLoading: false,
      total: 0,
      trainingStatus: _lifehikesInitData.trainingStatus,
      reportList: [],
      query: {
        page: 1,
        limit: 50,
        sort: '-start.utc',
        q: undefined,
        publish: undefined
      },
      checked: {
        drawTitle: '',
        id: '',
        title: true,
        internalTitle: true,
        description: true,
        eventDate: true,
        stages: true,
        report: true,
        stageDate: true,
        resources: true,
        tags: true,
        webinarInfo: true,
        clientName: true
      },
      basePublicUrl: ''
    };
  },
  async created() {
    this.basePublicUrl = process.env.VUE_APP_PUBLIC_DOMAIN.trim();
    await this.getList();
  },
  methods: {
    getUserPreviewUrl(reportId) {
      return process.env.VUE_APP_PUBLIC_DOMAIN.trim() + '/advanced/report/' + reportId;
    },
    getAdminPreviewUrl(reportId) {
      return process.env.VUE_APP_PUBLIC_DOMAIN.trim() + '/advanced/report/' + reportId;
    },
    checkPermission: _permission.default,
    search(pageNo) {
      this.query.page = pageNo;
      this.query.q = this.query.q === '' ? undefined : this.query.q;
      console.log('query:', this.query.q);
      this.getList();
    },
    deleteHikeAdvReport(id, title) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      var updatedPublishStatus = {
        id: id,
        publish: 'markdelete'
      };
      this.$confirm(`This will delete [ ${title} ]. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        var data = {
          publish: 'markdelete'
        };
        (0, _hikeAdvancedReport.updateAdvancedReport)(token, id, data).then(response => {
          this.search(this.query.page);
          const msg = 'Hike cohort report is deleted';
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'HikeAdvancedReport', `${_lifehikesInitData.userEvent.hikeAdvancedReport.delete}`, oEmail, `Hike Id: ${id}`);
        }).catch(error => {
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }).catch(() => {
        const msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _hikeAdvancedReport.getAdvancedReports)(token, this.query).then(response => {
        this.reportList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    isExipred(endUtc) {
      if (endUtc) {
        var now = _moment.default.utc();
        var end = _moment.default.utc(endUtc);
        return now > end;
      }
      return false;
    },
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'title') {
        order === 'ascending' ? this.query.sort = '+title' : this.query.sort = '-title';
      }
      if (prop === 'start') {
        order === 'ascending' ? this.query.sort = '+start.utc' : this.query.sort = '-start.utc';
      }
      if (prop === 'end') {
        order === 'ascending' ? this.query.sort = '+end.utc' : this.query.sort = '-end.utc';
      }
      if (prop === 'description') {
        order === 'ascending' ? this.query.sort = '+description' : this.query.sort = '-description';
      }
      if (prop === 'publish') {
        order === 'ascending' ? this.query.sort = '+publish' : this.query.sort = '-publish';
      }
      if (prop === 'updatedAt') {
        order === 'ascending' ? this.query.sort = '+updatedAt' : this.query.sort = '-updatedAt';
      }
      if (prop === 'internal.title') {
        order === 'ascending' ? this.query.sort = '+internal.title' : this.query.sort = '-internal.title';
      }
      if (prop === 'internal.opportunityNumber') {
        order === 'ascending' ? this.query.sort = '+internal.opportunityNumber' : this.query.sort = '-internal.opportunityNumber';
      }
      this.search(1);
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    }
  }
};